import { jsx as i } from "react/jsx-runtime";
import t from "styled-components";
import e from "../../../../utils/colors.js";
import { device as o } from "../../../../utils/device.js";
import r from "./List.js";
const s = t.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background-color: ${e.blueGrey75};
  min-width: 100%;

  @media ${o.isTablet}, ${o.isMobile} {
    min-width: 100%;
  }

  @media ${o.isDesktop} {
    position: absolute;
  }
`, a = () => /* @__PURE__ */ i(s, { children: /* @__PURE__ */ i(r, {}) });
export {
  a as default
};
